(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/button-row/button-row.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/button-row/button-row.js');
"use strict";

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const Button = svs.ui.ReactButton;
const ButtonRow = _ref => {
  let buttons = _ref.buttons,
    centerButton = _ref.centerButton,
    className = _ref.className;
  const classNames = [className];
  classNames.push(centerButton ? 'button-row-button-center' : 'button-row-button-left');
  return React.createElement("div", {
    className: "button-row-flex"
  }, React.createElement("div", {
    className: classNames.join(' ')
  }, buttons.map(button => {
    const buttonClassNames = button.className ? button.className.concat(' button-width-150') : 'button-width-150';
    return (
      React.createElement(Button, _extends({}, button, {
        className: buttonClassNames,
        size: 300
      }), button.label)
    );
  })));
};
svs.ticket_partner.sharedComponents.buttonRow.ButtonRow = ButtonRow;

 })(window);